import React from 'react'
import { Button, ConfirmationModal } from '@components/common'
import './ConfirmDeleteModal.css'

type ConfirmDeleteModalProps = {
  show: boolean
  onHide: () => void
  onConfirm: () => void
  entityName?: string
  title?: string
  message?: string
  confirmButtonText?: string
  confirmDisabled?: boolean
  /** When set, replaces the default “{message} {entityName}?” body. */
  bodyText?: string
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  show,
  onHide,
  onConfirm,
  entityName = '',
  title = 'Confirm deletion',
  message = 'Are you sure you want to delete',
  confirmButtonText = 'Delete',
  confirmDisabled = false,
  bodyText,
}) => {
  const bodyMessage =
    bodyText ??
    (entityName ? `${message} ${entityName}?` : 'This cannot be undone.')

  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      title={title}
      className="confirmation-modal--alert delete-confirm-modal"
      headerClassName="confirmation-modal__header"
      size="md"
      body={
        <div className="confirmation-modal__body">
          <p className="confirmation-modal__message">{bodyMessage}</p>
        </div>
      }
      footer={
        <div className="confirmation-modal__footer">
          <Button className="button-secondary" size="md" onClick={onHide}>
            Cancel
          </Button>
          <Button
            className="button-destructive-primary"
            size="md"
            onClick={onConfirm}
            disabled={confirmDisabled}
          >
            {confirmButtonText}
          </Button>
        </div>
      }
    />
  )
}

export default ConfirmDeleteModal
